<div class="bmc-ai-jobs">
  <bzg-checkbox class="bmc-ai-jobs__checkbox" [checked]="currentJob?.enabled" [ngModel]="currentJob?.enabled" (ngModelChange)="changeEnableSchedule()">
    {{'AIJOBS.ENABLE_REPLICATION' | translate}}
  </bzg-checkbox>
  <div class="bmc-ai-jobs__frequency">
    <div class="bmc-ai-jobs__frequency-title">
      {{'AIJOBS.FREQUENCY' | translate}}
    </div>
    <bzg-radio-group [value]="currentJob.schedules[0].frequency.type" isHorizontal="true" (change)="changeFrequency($event.value)" class="bmc-ai-jobs__frequency-options"
      [disabled]="!currentJob?.enabled">
      <!-- <bzg-radio-button value="Daily">{{'AIJOBS.DAILY' | translate}}</bzg-radio-button> -->
      <bzg-radio-button value="Weekly">{{'AIJOBS.WEEKLY' | translate}}</bzg-radio-button>
      <bzg-radio-button value="Monthly">{{'AIJOBS.MONTHLY' | translate}}</bzg-radio-button>
      <bzg-radio-button value="Annually">{{'AIJOBS.ANNUALLY' | translate}}</bzg-radio-button>
    </bzg-radio-group>
  </div>
  <div class="bmc-ai-jobs__schedule">
    <div class="bmc-ai-jobs__schedule-section">
      <div class="bmc-ai-jobs__schedule-section-title">
        {{'AIJOBS.SCHEDULE_BEGINING' | translate}}
      </div>
      <div class="bmc-ai-jobs__schedule-section-date">
        <bz-date-time-picker 
          [currentDate]="currentJob?.schedules[0]?.displayStartDate || currentJob?.schedules[0]?.startDate" 
          [dateMax]="dateMax" 
          [isDisabled]="!currentJob?.enabled" 
          (valueChange)="onDateChange($event)"></bz-date-time-picker>
      </div>  
    </div>   
    <div class="bmc-ai-jobs__schedule-section-hidden">
      <div class="bmc-ai-jobs__schedule-section-title">
        {{'AIJOBS.TERMINATE' | translate}}
      </div>
      <div class="bmc-ai-jobs__schedule-section-date">
        <bzg-date-picker [isDisabled]="!currentJob?.enabled" ></bzg-date-picker>
      </div>
    </div>
  </div>
  <!-- Warning message for past dates -->
  <div *ngIf="showPastDateWarning && currentJob?.enabled" class="bmc-ai-jobs__warning">
    <div class="bmc-ai-jobs__warning-content">
      <bzg-icon [nameIcon]="'warning'" [size]="20" class="bz-space--inline-xs bz-icon-color--warning"></bzg-icon>
      <div class="bmc-ai-jobs__warning-text">
        {{ 'AIJOBS.PAST_DATE_WARNING' | translate }}
      </div>
    </div>
  </div>
  <div class="bmc-ai-jobs__footer">
    <bzg-button-secondary (click)="cancelChanges()">{{ 'GLOBAL.CANCEL' | translate}}</bzg-button-secondary>
    <bzg-button-primary (click)="applyChanges()">{{ 'GLOBAL.APPLY' | translate}}</bzg-button-primary>
  </div>
</div>